export default __webpack_public_path__ + "static/media/promos-icon.7eb641d3.webp";